







import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class BtnStockSchedule extends Vue {
  @Prop({ default: null }) public commodity: Common.Commodity;
  @Prop({ default: null }) public sku: Common.Commodity;  
  @Prop({ default: null }) public stockDate: Date; 
  @Prop({ default: null }) public segment: Common.Segment;  

  public showPopover :boolean = false;
  public target: HTMLElement = null;

  public onFuncClicked(event: Event){
    //targetとなるボタン
    this.target = event.srcElement as HTMLElement;

    if (this.showPopover) this.showPopover = false;
    else this.showPopover = true;

  }
}
